
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterAcdcOff as ObiConverterAcdcOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-acdc-off.js';
 
 
 

 
 export const ObiConverterAcdcOff = createComponent({
   react: React,
   tagName: 'obi-converter-acdc-off',
   elementClass: ObiConverterAcdcOffElement,
   events: {
     
   }
  });
 
 